import React, { useEffect, useState } from "react";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";

//Assets
import "~/assets/sass/pages/mypage/admin/business.scss";
import "~/assets/sass/pages/mypage/admin/business/uncertified.scss";
import "~/assets/sass/pages/mypage/admin/business/certified.scss";
import "~/assets/sass/pages/mypage/admin/business/processing.scss";
import { Case, If } from "~/common/components/If";
import Uncertified from "./contents/Uncertified";
import Complete from "./contents/Complete";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useGlobalStore } from "~/store";
import useRepository from "~/common/hooks/useRepository";
import { COMPANY_INFO } from "~/store/company/repository";

const BusinessPage = () => {
	const MENU = ["admin", "business"];
	const TYPE = "myPage";
	const [bsnList, setBsnList] = useState(null);
	const [imageDone, setImageDone] = useState("");

	const bsnListRequest = useRequest("get", "/vc/admin/business");

	const [getCompanyInfo] = useRepository(COMPANY_INFO);

	useEffect(() => {
		getCompanyInfo();
	}, []);

	const [
		{
			company: { info },
		},
	] = useGlobalStore();

	useEffect(() => {
		bsnListRequest.singleCall();
	});

	useEffect(() => {
		switch (bsnListRequest.state) {
			case API_STATE.done:
				const result = bsnListRequest.response;
				setBsnList(result.data);
				setImageDone(result.data.imgUrl);
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}
	}, [bsnListRequest.state, bsnListRequest.response, bsnListRequest.error]);

	useEffect(() => {
		const curStep =
			bsnList === null ? "uncertified" : bsnList.status === "대기" ? "processing" : "done";
		setStep(curStep);
	}, [bsnList]);

	const [step, setStep] = useState("uncertified");

	return (
		<NavbarAndSidebarLayout menu={MENU} type={TYPE}>
			<PageHeader />
			<If condition={step} {...{ setStep, info }}>
				<Case condition="uncertified">
					{/*-----미인증-----*/}
					<Uncertified />
				</Case>
				<Case condition="processing">
					{/*-----심사중-----*/}
					{/* <Processing /> */}
					<Complete {...{ imageDone }} />
				</Case>
				<Case condition="done">
					{/*-----인증-----*/}
					<Complete {...{ imageDone }} />
				</Case>
			</If>
		</NavbarAndSidebarLayout>
	);
};
export default BusinessPage;
